import React, { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { ProductProps } from '../containers/ConnectedProduct'
import ProductMap from './ProductMap'
import ProductStock from './ProductStock'
import ProductInfo from './ProductInfo'

const Product: React.FC<ProductProps & RouteComponentProps<{ barcode: string }>> = props => {
	useEffect(() => {
		if (props.price === null) {
			props.searchBarcode(props.match.params.barcode)
		}
		// eslint-disable-next-line
	}, [props.price])

	if (typeof props.product === 'undefined') {
		return null
	}

	return (
		<div className="grid">
			<div className="grid__row grid__row--spacing-top-3x grid__row--spacing-bottom">
				<div className="grid__col grid__col--12">
					<div className="title title--align-center">
						{
							props.product?.[`name_${props.locale}`] !== '' ?
								props.product?.[`name_${props.locale}`] :
								props.product?.name
						}
					</div>
				</div>
			</div>

			<ProductInfo
				product={props.product}
				bestBefore={props.bestBefore}
				price={props.price}
				locale={props.locale}
			/>

			<ProductMap locations={props.locations} />

			<ProductStock stocks={props.stocks} />

		</div>
	)
}

export default withRouter(Product)
